
export class WarehouseHandlingModal {
    public constructor(
        ) {
    }

    public id?: string;
    public startDate?: string;
    public endDate?: string;
    public stockId?: string;
    public stockMessage?: string;
    public stockName?: string;
}
